module.exports = __webpack_public_path__ + "img/scene_sunset_big@2x.0275b8c2.png";